import { forkify } from '@/shared/lib/core/fork';
import axios from 'axios';
import handleApiError from '@/shared/api/handleApiError';

export function methodHasBody(method: string) {
  return ['post', 'put'].includes(method);
}

/**
 * Обращение к сервису ПЛ
 */
export const serviceGet = forkify(async (fork, args) => {
  try {
    const [url, config] = args;
    const { data } = await axios.get(url, config);
    fork.resolve(data);
  } catch (e) {
    fork.reject(e);
    handleApiError(e);
  }
});
